import { LinearProgress, Stack, Typography, linearProgressClasses, styled } from "@mui/material";
import { useMemo } from "react";
import { useTranslation } from "react-i18next";
import useProfile from "state/useProfile";
import { NO_LIMIT_OF_USAGE } from "utility/constants";

type BorderLinearProgressProps = {
  colorbar: string;
  disabled: boolean;
};
const BorderLinearProgress = styled(LinearProgress)<BorderLinearProgressProps>(
  ({ theme, colorbar, disabled }) => ({
    minHeight: 6,
    borderRadius: 8,
    ...(disabled && {
      [`&.${linearProgressClasses.colorPrimary}`]: {
        backgroundColor: "#d6d6d6",
      },
    }),
    [`& .${linearProgressClasses.bar}`]: {
      backgroundColor: colorbar,
    },
  })
);

const ProfileUsage = () => {
  const { t } = useTranslation();
  const { userPackage } = useProfile();
  const {
    isUnlimitOfUsage,
    colorWarningUsage,
    colorLabelPackage,
    isLimitReached,
    maxUsage: limitOfUsage,
    remainingUsage,
    status,
  } = userPackage;

  const isExpired = useMemo(() => status === "inactive", [status]);
  const leftover = useMemo(() => (remainingUsage < 0 ? 0 : remainingUsage), [remainingUsage]);
  const percentage = useMemo(() => {
    if (limitOfUsage === NO_LIMIT_OF_USAGE) return 100;
    return (remainingUsage / limitOfUsage) * 100;
  }, [remainingUsage, limitOfUsage]);
  
  if(isExpired) return <></>
  return (
    <>
      <BorderLinearProgress
        variant="determinate"
        value={percentage}
        colorbar={colorWarningUsage().bar}
        disabled={isLimitReached}
      />
      <Stack direction={"row"} justifyContent="space-between" sx={{ mt: 0.5 }}>
        <Typography variant="helper">{t("remain")}</Typography>
        {isUnlimitOfUsage ? (
          <Typography variant="helper" color="primary.main">
            {t("no limit")}
          </Typography>
        ) : (
          <Typography
            variant="helper"
            color={colorWarningUsage().label}
          >{`${leftover}/${limitOfUsage}`}</Typography>
        )}
      </Stack>
    </>
  );
};

export default ProfileUsage;
